module.exports = __webpack_public_path__ + "img/Innovation.f277edbe.gif";